var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.25 11.25 L 99.75 11.25 L 99.75 99.75 L 11.25 99.75 Z M 11.25 11.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 112.003906 0 L 112.003906 112.003906 L 0 112.003906 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 11.25 11.25 L 99.75 11.25 L 99.75 99.75 L 11.25 99.75 L 11.25 11.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 56.25 0 C 25.234375 0 0 25.234375 0 56.25 C 0 87.265625 25.234375 112.5 56.25 112.5 C 87.265625 112.5 112.5 87.265625 112.5 56.25 C 112.5 25.234375 87.265625 0 56.25 0 Z M 56.25 14.675781 C 65.691406 14.675781 73.371094 22.351562 73.371094 31.792969 C 73.371094 41.234375 65.691406 48.914062 56.25 48.914062 C 46.808594 48.914062 39.128906 41.234375 39.128906 31.792969 C 39.128906 22.351562 46.808594 14.675781 56.25 14.675781 Z M 85.597656 88.042969 L 26.902344 88.042969 C 25.550781 88.042969 24.457031 86.949219 24.457031 85.597656 C 24.457031 68.066406 38.71875 53.804688 56.25 53.804688 C 73.78125 53.804688 88.042969 68.066406 88.042969 85.597656 C 88.042969 86.949219 86.949219 88.042969 85.597656 88.042969 Z M 85.597656 88.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.e4007cceea217bb037c89b015cd65b98.svg";
export { ForwardRef as ReactComponent };